<template>
    <form-row title="Is a Zoning Change Required?"
        :no_border="! zoning_change_is_required"
        :class="zoning_change_is_required ? '' : 'mt-8'"
    >
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean-reactive
                name="zoning_change_is_required"
                v-model="zoning_change_is_required"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="zoning_change_is_required"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Required:"
                v-model="zoning_change_required_date"
                name="zoning_change_required_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        commercial: {},
        read_only: { default: false },
    },

    computed: {
        zoning_change_is_required: {
            get() {
                return store.state.zoning_change_is_required;
            },
            set(val) {
                store.state.zoning_change_is_required = val;
            },
        },
        zoning_change_required_date: {
            get() {
                return store.state.zoning_change_required_date;
            },
            set(val) {
                store.state.zoning_change_required_date = val;
            },
        },
    },
}
</script>
